import React, { useContext, useEffect, useState } from "react";
import Header from "../Header";
import Footer from "../Footer";
import MetisMenu from "react-metismenu";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AuthContext from "../../context/auth/authContext";
import setAuthToken from "../../utils/setAuthToken";
import axios from "axios";
import CustomLink from "./CustomLink";

const contentInit = [{ id: 1, icon: "home", label: "Home", to: "/home" }];

const getMenu = (userId) => axios.get(process.env.REACT_APP_API_URL + "/api/menu/" + userId);

const Layout = props => {
  const [content, setContent] = useState(contentInit);
  const authContext = useContext(AuthContext);
  const [activeLink, setActiveLink] = useState("");
  //const [isResizing, setIsResizing] = useState(false);
  const [isMetisMenuVisible, setMetisMenuVisible] = useState( window.innerWidth > 600 );
  const [isOpenMetis, setOpenMetis] = useState(false);

  useEffect(() => {
    function handleResize () {
        setMetisMenuVisible(window.innerWidth > 600? 1:0 );
    }

    authContext.checkAuth();
    if (localStorage.token) {
      setAuthToken(localStorage.token);
      const userId =
        JSON.parse(localStorage.getItem("user")) === null
        ? null
        : JSON.parse(localStorage.getItem("user"))[0].Id;
      const permission =
        JSON.parse(localStorage.getItem("permission")) === null
        ? null
        : JSON.parse(localStorage.getItem("permission"));

      const pagePermission = permission.filter(c => c.MenuId === props.menuId);
      if (pagePermission[0] && !pagePermission[0].IsView) {
        //set Go Home page
        window.location.href = "/home";
      } else{
        getMenu(userId).then(res => {
          setContent(res.data);
          setActiveLink(props.activeLinkTo);
          window.addEventListener("resize", handleResize);
        });
      }
    }
    return function cleanupListener () {
      window.removeEventListener("resize", handleResize);
    }
    //eslint-disable-next-line
  }, []);

  const rendernavicon = () => {
    if (isOpenMetis) {
      return (<i className="fa fa-times navmatis" onClick={() => {setOpenMetis(false)}}></i>)
    } else {
      return (<i className="fa fa-bars navmatis" onClick={() => {setOpenMetis(true)}}></i>)
    }
  }

  return (
    <div className="App">
      
      {(isMetisMenuVisible || isOpenMetis) && (
        <MetisMenu
          LinkComponent={CustomLink}
          content={content}
          activeLinkFromLocation
          activeLinkTo={activeLink}
        />
      )}
      <button className="navbutton" type="button" 
      style={{zIndex:"1", marginLeft: isOpenMetis ? "207px" : "0px" }} >
        {rendernavicon()}
      </button>

      <div style={{ paddingLeft: !isMetisMenuVisible ? 0 : 207 , backgroundColor : "#efefef"}}>
        <Header />
        {props.children}
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
